import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { AuthComponent } from './theme/layout/auth/auth.component';
import { AuthGuard } from './core/helpers/auth/auth.guard';
import { getUnauthorizedRolesByItems } from './core/helpers/role/role-helper';
import { MenuItem } from './core/helpers/enum/menu.enums';

const routes: Routes = [
    {
        path: '',
        component: AdminComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                redirectTo: 'dashboard/dash-customer',
                pathMatch: 'full',
            },
            {
                path: 'admin',
                loadChildren: () => import('./pages/admin/admin.module').then((module) => module.AdminModule),
            },
            {
                path: 'dashboard',
                data: { unauthorized: getUnauthorizedRolesByItems(MenuItem.DashCustomer) },
                loadChildren: () => import('./pages/dashboard/dashboard.module').then((module) => module.DashboardModule),
            },
            {
                path: 'schedule',
                data: { unauthorized: getUnauthorizedRolesByItems(MenuItem.CaseAdd) },
                loadChildren: () => import('./pages/schedule/schedule.module').then((module) => module.ScheduleModule),
            },
            {
                path: 'vendor',
                loadChildren: () => import('./pages/vendor/vendor.module').then((module) => module.VendorModule),
            },
        ],
    },
    {
        path: '',
        component: AuthComponent,
        children: [
            {
                path: 'login',
                loadChildren: () => import('./pages/login/login.module').then((module) => module.LoginModule),
            },
            {
                path: 'maintenance',
                loadChildren: () => import('./pages/maintenance/maintenance.module').then((module) => module.MaintenanceModule),
            },
        ],
    },
    { path: '**', redirectTo: '/maintenance/error' },
    // otherwise redirect to home
    // { path: '**', redirectTo: '' }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            relativeLinkResolution: 'legacy',
            useHash: true,
            anchorScrolling: 'enabled',
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
